import * as RadixAccordion from "@radix-ui/react-accordion";
import { type TypeAccordionItemProps } from "./AccordionTypes";

export const AccordionItem = ({ children, value }: TypeAccordionItemProps) => {
  return (
    <RadixAccordion.Item className="accordion-item" value={value}>
      {children}
    </RadixAccordion.Item>
  );
};
